import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Bradley Nelson
 * id 8213DABD-5CCB-415F-9457-A0A68B0F8179
 * name watch-export-variant
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/watch-export-variant.svg
 * tags
 * - Device / Tech 
 */
export const WatchExportVariantIcon = createSvgIcon(<><path d="M14,11H19L16.5,8.5L17.92,7.08L22.84,12L17.92,16.92L16.5,15.5L19,13H14V11M8,0H16L16.83,5H17C17.28,5 17.54,5.06 17.78,5.16L15.94,7H7V17H15.94L17.78,18.84C17.54,18.94 17.28,19 17,19H16.83L16,24H8L7.17,19H7A2,2 0 0,1 5,17V7C5,5.89 5.9,5 7,5H7.17L8,0Z" /></>, 'WatchExportVariantIcon');
export default WatchExportVariantIcon